import { css } from '@emotion/react';

export const navigationStyles = css`
  width: 100%;
  background-color: var(--surface-page);
  border-bottom: 1px solid var(--border-primary);
`;

export const navigationMarketingStyles = css`
  width: 100%;
  background-color: var(--surface-subtle);
  border-bottom: none;
`;

export const hamburgerButtonStyles = css`
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid var(--border-focus);
    outline-offset: 2px;
  }

  @media (min-width: 768px) {
    display: none;
  }
`;

export const centeredLogoStyles = css`
  transform: translate(-50%, -50%);
  max-width: 150px;

  @media (min-width: 768px) {
    display: none;
  }
`;

export const desktopLogoStyles = css`
  display: none;

  @media (min-width: 768px) {
    display: block;
  }
`;

export const containerStyles = css`
  @media (min-width: 768px) {
    justify-content: space-between;
    position: static;
  }
`;

export const marketingContainerStyles = css`
  min-height: 80px;

  @media (min-width: 768px) {
    justify-content: space-between;
    position: static;
    min-height: 80px;
  }
`;

export const logoStyles = css`
  width: 100%;

  @media (min-width: 768px) {
    width: initial;
  }
`;

export const desktopNavStyles = css`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    gap: var(--spacing-8);
  }
`;

export const marketingDesktopNavStyles = css`
  display: none;

  @media (min-width: 768px) {
    display: flex;
    align-items: center;
    gap: var(--spacing-4);
  }
`;

export const navLinksStyles = css`
  display: flex;
  align-items: center;
  gap: var(--spacing-6);
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const marketingNavLinksStyles = css`
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const marketingNavLinkStyles = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: var(--spacing-3);
  color: var(--text-primary);
  white-space: nowrap;

  &:hover {
    color: var(--text-action-hover);
  }
`;

export const navLinkStyles = css`
  text-decoration: none;
  color: var(--text-primary);
  font-weight: 500;
  font-size: 16px;
  transition: color 0.2s ease;

  &:hover {
    color: var(--text-action-hover);
  }

  &:focus-visible {
    outline: 2px solid var(--border-focus);
    outline-offset: 2px;
  }
`;

export const avatarPlaceholderStyles = css`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: var(--surface-neutral);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: var(--border-primary);
  }

  &:focus-visible {
    outline: 2px solid var(--border-focus);
    outline-offset: 2px;
  }
`;
